export default __webpack_public_path__ + "static/media/ShareIcon.399b82a0.svg";